"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _changeWindowProperty = require("./changeWindowProperty");
Object.keys(_changeWindowProperty).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in exports && exports[key] === _changeWindowProperty[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _changeWindowProperty[key];
        }
    });
}); //# sourceMappingURL=index.js.map
